<template>
  <div class="min-h-screen">
    <Head :title="`Cuota ${order.number_order}`" />
    
    <!-- Header Section -->
    <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
      <div class="flex items-center justify-between mb-6">
        <div class="flex items-center space-x-4">
          <button 
            class="inline-flex items-center px-3 py-2 border border-transparent text-sm leading-4 font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 transition-colors duration-200"
            @click="back()"
          >
            <svg class="h-4 w-4 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M10 19l-7-7m0 0l7-7m-7 7h18" />
            </svg>
            Volver
          </button>
          <h1 class="text-2xl font-bold text-gray-900">Cuota #{{order.number_order}}</h1>
        </div>

        <!-- Action Buttons -->
        <div class="flex items-center space-x-2">
          <a 
            target="_blank" 
            :href="`/orders/${order.id}/report-storer`" 
            class="inline-flex items-center px-3 py-2 border border-transparent text-sm leading-4 font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 transition-colors duration-200"
          >
            <svg class="h-4 w-4 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17 17h2a2 2 0 002-2v-4a2 2 0 00-2-2H5a2 2 0 00-2 2v4a2 2 0 002 2h2m2 4h6a2 2 0 002-2v-4a2 2 0 00-2-2H9a2 2 0 00-2 2v4a2 2 0 002 2zm8-12V5a2 2 0 00-2-2H9a2 2 0 00-2 2v4h10z" />
            </svg>
            Aviso de cobro
          </a>
          <button 
            @click="shareWhatsApp"
            class="inline-flex items-center px-3 py-2 border border-transparent text-sm leading-4 font-medium rounded-md text-white bg-green-600 hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-green-500 transition-colors duration-200"
          >
            <svg class="h-4 w-4 mr-2" fill="currentColor" viewBox="0 0 24 24">
              <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/>
            </svg>
            Compartir por WhatsApp
          </button>
          <button 
            @click="shareEmail"
            class="inline-flex items-center px-3 py-2 border border-transparent text-sm leading-4 font-medium rounded-md text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 transition-colors duration-200"
          >
            <svg class="h-4 w-4 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
            </svg>
            Compartir por correo
          </button>
        </div>
      </div>

      <!-- Order Details Section -->
      <div class="bg-white shadow-sm rounded-lg overflow-hidden mb-6">
        <div class="p-6">
          <div class="grid grid-cols-1 md:grid-cols-2 gap-6">
            <div>
              <div class="flex items-center justify-between mb-4">
                <h2 class="text-lg font-medium text-gray-900">Información del Propietario</h2>
                <button 
                  v-if="!isEditingClient && role === 'admin'"
                  @click="startEditClient"
                  class="inline-flex items-center px-3 py-1.5 border border-transparent text-xs font-medium rounded text-indigo-700 bg-indigo-100 hover:bg-indigo-200"
                >
                  Cambiar
                </button>
                <div v-else-if="isEditingClient" class="flex space-x-2">
                  <button 
                    @click="isEditingClient = false"
                    class="inline-flex items-center px-3 py-1.5 border border-gray-300 text-xs font-medium rounded text-gray-700 bg-white hover:bg-gray-50"
                  >
                    Cancelar
                  </button>
                  <button 
                    @click="saveClient"
                    class="inline-flex items-center px-3 py-1.5 border border-transparent text-xs font-medium rounded text-white bg-indigo-600 hover:bg-indigo-700"
                  >
                    Guardar
                  </button>
                </div>
              </div>
              <div v-if="!isEditingClient">
                <dl class="space-y-3">
                  <div class="flex justify-between">
                    <dt class="text-sm font-medium text-gray-500">Nombre:</dt>
                    <dd class="text-sm text-gray-900">{{ order.client.name }}</dd>
                  </div>
                  <div class="flex justify-between">
                    <dt class="text-sm font-medium text-gray-500">Identificación:</dt>
                    <dd class="text-sm text-gray-900">{{ order.client.identification }}</dd>
                  </div>
                  <div class="flex justify-between">
                    <dt class="text-sm font-medium text-gray-500">Email:</dt>
                    <dd class="text-sm text-gray-900">{{ order.client.email }}</dd>
                  </div>
                  <div class="flex justify-between">
                    <dt class="text-sm font-medium text-gray-500">Teléfono:</dt>
                    <dd class="text-sm text-gray-900">{{ order.client.phone }}</dd>
                  </div>
                </dl>
              </div>
              <div v-else>
                <div class="space-y-4">
                  <div v-if="!selectedNewClient" class="w-full">
                    <text-input 
                      v-model="clientSearchTerm" 
                      label="Buscar propietario"
                      placeholder="Ingrese nombre o identificación"
                      class="w-full"
                    />
                    <div v-if="clients && clients.length > 0" class="mt-2 space-y-2 max-h-48 overflow-y-auto">
                      <div 
                        v-for="c in clients" 
                        :key="c.id" 
                        class="p-2 bg-gray-50 hover:bg-gray-100 rounded-md cursor-pointer transition-colors duration-150"
                        @click="selectNewClient(c)"
                      >
                        <div class="flex justify-between items-center">
                          <div>
                            <p class="text-sm font-medium text-gray-900">{{ c.name }}</p>
                            <p class="text-xs text-gray-500">{{ c.identification }}</p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div v-else class="p-3 bg-blue-50 rounded-lg border border-blue-200">
                    <div class="flex justify-between items-start">
                      <div>
                        <h3 class="text-xs font-medium text-blue-900">Nuevo propietario seleccionado</h3>
                        <p class="mt-1 text-sm text-blue-700">{{ selectedNewClient.name }}</p>
                        <p class="text-xs text-blue-600">{{ selectedNewClient.identification }}</p>
                      </div>
                      <button 
                        @click="selectedNewClient = null" 
                        class="text-xs font-medium text-blue-600 hover:text-blue-800"
                      >
                        Cambiar
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div>
              <h2 class="text-lg font-medium text-gray-900 mb-4">Detalles de la Cuota</h2>
              <dl class="space-y-3">
                <div class="flex justify-between">
                  <dt class="text-sm font-medium text-gray-500">Balance:</dt>
                  <dd class="text-sm text-gray-900">${{ order.balance }}</dd>
                </div>
                <div class="flex justify-between">
                  <dt class="text-sm font-medium text-gray-500">Balance Bs:</dt>
                  <dd class="text-sm text-gray-900">{{ order.balance * change }}</dd>
                </div>
                <div class="flex justify-between">
                  <dt class="text-sm font-medium text-gray-500">Deuda:</dt>
                  <dd class="text-sm text-gray-900">${{ order.total - order.balance }}</dd>
                </div>
                <div class="flex justify-between">
                  <dt class="text-sm font-medium text-gray-500">Deuda Bs:</dt>
                  <dd class="text-sm text-gray-900">{{ (order.total - order.balance) * change }}</dd>
                </div>
                <div class="flex justify-between">
                  <dt class="text-sm font-medium text-gray-500">Total:</dt>
                  <dd class="text-sm font-medium text-gray-900">${{ order.total }}</dd>
                </div>
                <div class="flex justify-between">
                  <dt class="text-sm font-medium text-gray-500">Total Bs:</dt>
                  <dd class="text-sm font-medium text-gray-900">{{ order.total * change }}</dd>
                </div>
                <div class="flex justify-between items-center">
                  <dt class="text-sm font-medium text-gray-500">Fecha Emisión:</dt>
                  <dd class="text-sm text-gray-900 font-medium">
                    <span v-if="!isEditing">{{ order.date ? formatDate(order.date) : 'N/A' }}</span>
                    <input v-else type="date" v-model="editForm.date" class="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block sm:text-xs border-gray-300 rounded-md py-1 px-2 text-xs" />
                  </dd>
                </div>
                <div class="flex justify-between">
                  <dt class="text-sm font-medium text-gray-500">Estado:</dt>
                  <dd class="text-sm">
                    <span 
                      :class="[
                        'px-2 inline-flex text-xs leading-5 font-semibold rounded-full',
                        getStatusClass(order.order_state)
                      ]"
                    >
                      {{ getStatusText(order.order_state) }}
                    </span>
                  </dd>
                </div>
              </dl>
            </div>
          </div>
        </div>
      </div>

      <!-- Payments Section (Multi-Moneda Component) -->
      <Payment 
        :order="order" 
        :payment-methods="paymentMethods" 
        :change="change" 
        :role="role" 
      />

      <!-- Products Section -->
      <div class="bg-white shadow-sm rounded-lg overflow-hidden mb-6">
        <div class="p-6">
          <div class="flex items-center justify-between mb-6">
            <h2 class="text-lg font-medium text-gray-900">Productos</h2>
            <button 
              v-if="!isEditing && role === 'admin'"
              @click="startEdit"
              class="inline-flex items-center px-3 py-1.5 border border-transparent text-xs font-medium rounded text-indigo-700 bg-indigo-100 hover:bg-indigo-200"
            >
              Editar
            </button>
            <div v-else class="flex space-x-2">
              <button 
                @click="cancelEdit"
                class="inline-flex items-center px-3 py-1.5 border border-gray-300 text-xs font-medium rounded text-gray-700 bg-white hover:bg-gray-50"
              >
                Cancelar
              </button>
              <button 
                @click="saveEdit"
                class="inline-flex items-center px-3 py-1.5 border border-transparent text-xs font-medium rounded text-white bg-indigo-600 hover:bg-indigo-700"
              >
                Guardar
              </button>
            </div>
          </div>
          <div class="overflow-x-auto">
            <table class="min-w-full divide-y divide-gray-200">
              <thead class="bg-gray-50">
                <tr>
                  <th scope="col" class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Producto</th>
                  <th scope="col" class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Cantidad</th>
                  <th scope="col" class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Precio</th>
                  <th scope="col" class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Total</th>
                  <th v-if="isEditing" scope="col" class="px-6 py-3"></th>
                </tr>
              </thead>
              <tbody class="bg-white divide-y divide-gray-200">
                <tr v-for="(product, key) in (isEditing ? editForm.products : order.products)" 
                    :key="key" 
                    :class="[product.dispatch ? 'bg-blue-50' : '']"
                >
                  <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                    <span v-if="!isEditing">{{ product.product ? product.product.name : product.name }}</span>
                    <input v-else type="text" v-model="product.name" class="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md py-1 px-2" placeholder="Concepto del cobro" />
                  </td>
                  <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                    <span v-if="!isEditing">{{ product.quantity }}</span>
                    <input v-else type="number" v-model="product.quantity" class="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-20 sm:text-sm border-gray-300 rounded-md">
                  </td>
                  <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                    <span v-if="!isEditing">${{ product.price }}</span>
                    <input v-else type="number" step="0.01" v-model="product.price" class="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-24 sm:text-sm border-gray-300 rounded-md">
                  </td>
                  <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                    ${{ Math.round(product.price * product.quantity) }}
                  </td>
                  <td v-if="isEditing" class="px-6 py-4 whitespace-nowrap text-right text-sm font-medium">
                    <button 
                      @click="removeProduct(key)"
                      class="text-red-600 hover:text-red-900"
                    >
                      <svg class="h-5 w-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
                      </svg>
                    </button>
                  </td>
                </tr>
              </tbody>
              <tfoot class="bg-gray-50">
                <tr v-if="isEditing">
                  <td colspan="5" class="px-6 py-4 text-left">
                    <button 
                      @click="addQuickProduct"
                      class="inline-flex items-center px-3 py-1.5 border border-transparent text-xs font-medium rounded text-indigo-700 bg-indigo-100 hover:bg-indigo-200"
                    >
                      + Agregar concepto
                    </button>
                  </td>
                </tr>
                <tr v-if="isEditing">
                  <td colspan="3" class="px-6 py-4 text-right text-sm font-medium text-gray-500">Descuento (%)</td>
                  <td class="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">
                    <input type="number" step="0.01" v-model="editForm.discount" class="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-24 sm:text-sm border-gray-300 rounded-md">
                  </td>
                  <td v-if="isEditing"></td>
                </tr>
                <tr>
                  <td colspan="3" class="px-6 py-4 text-right text-sm font-medium text-gray-500">Total</td>
                  <td class="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">${{ isEditing ? calculatedTotal : order.total }}</td>
                  <td v-if="isEditing"></td>
                </tr>
              </tfoot>
            </table>
          </div>

          <div v-if="order.order_state == 'delivery'" class="mt-6">
            <button 
              @click="addDispatch" 
              class="inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 transition-colors duration-200"
            >
              <svg class="h-4 w-4 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 8h14M5 8a2 2 0 110-4h14a2 2 0 110 4M5 8v10a2 2 0 002 2h10a2 2 0 002-2V8m-9 4h4" />
              </svg>
              Despachar productos
            </button>
          </div>
        </div>
      </div>

      <!-- Cancel Order Section -->
      <div class="flex justify-end">
        <button 
          v-if="order.order_state != 'cancel'" 
          @click="cancelOrder()" 
          class="inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md text-white bg-red-600 hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500 transition-colors duration-200"
        >
          <svg class="h-4 w-4 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
          </svg>
          Anular Orden
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { Head, Link } from '@inertiajs/inertia-vue3'
import Layout from '@/Shared/Layout'
import TextInput from '@/Shared/TextInput.vue'
import Payment from '@/Shared/Payment.vue'

export default {
  components: {
    Head,
    Link,
    TextInput,
    Payment,
  },
  layout: Layout,
  props: {
    order: Object,
    dispatches: Object,
    change: Number,
    paymentMethods: Array,
    clients: Array
  },
  data() {
    return {
      role: this.$parent.auth.user.role,
      isEditing: false,
      isEditingClient: false,
      clientSearchTerm: '',
      selectedNewClient: null,
      clientForm: this.$inertia.form({
        client_id: this.order.client_id,
      }),
      editForm: this.$inertia.form({
        date: this.order.date ? this.order.date.substring(0, 10) : '',
        products: [],
        discount: 0,
      }),
      products: this.$inertia.form({
        products: this.order.products,
        order_id: this.order.id,
      }),
    }
  },
  computed: {
    calculatedTotal() {
      let total = 0;
      this.editForm.products.forEach(p => {
        total += (p.price * p.quantity);
      });
      if (this.editForm.discount > 0) {
        total = total - (total * (this.editForm.discount / 100));
      }
      return Math.round(total);
    }
  },
  watch: {
    clientSearchTerm(value) {
      this.$inertia.get(`/orders/${this.order.id}`, { search: { client: value } }, {
        preserveState: true,
        preserveScroll: true,
        replace: true,
        only: ['clients']
      });
    }
  },
  methods: {
    formatDate(val) {
      if (!val) return '';
      const parts = val.substring(0, 10).split('-');
      if (parts.length === 3) {
        return `${parts[2]}/${parts[1]}/${parts[0]}`;
      }
      return val;
    },
    startEditClient() {
      this.isEditingClient = true;
      this.selectedNewClient = null;
      this.clientSearchTerm = '';
    },
    selectNewClient(client) {
      this.selectedNewClient = client;
      this.clientForm.client_id = client.id;
    },
    saveClient() {
      if (!this.selectedNewClient) {
        alert('Debe seleccionar un propietario.');
        return;
      }
      if (confirm('¿Estás seguro de cambiar el propietario de esta cuota?')) {
        this.clientForm.put(`/orders/${this.order.id}`, {
          preserveScroll: true,
          onSuccess: () => {
            this.isEditingClient = false;
          }
        });
      }
    },
    addQuickProduct() {
      this.editForm.products.push({
        id: 'quick_' + Date.now(),
        quick: true,
        name: '',
        quantity: 1,
        price: 0
      });
    },
    removeProduct(index) {
      if (confirm('¿Estás seguro de eliminar este concepto?')) {
        this.editForm.products.splice(index, 1);
      }
    },
    startEdit() {
      this.isEditing = true;
      this.editForm.date = this.order.date ? this.order.date.substring(0, 10) : '';
      this.editForm.products = this.order.products.map(p => ({
        id: p.id,
        product_id: p.product_id,
        name: p.product ? p.product.name : (p.name || ''),
        quantity: p.quantity,
        price: p.price,
        total: p.total,
        quick: p.quick
      }));
      this.editForm.discount = 0;
    },
    cancelEdit() {
      this.isEditing = false;
      this.editForm.date = this.order.date ? this.order.date.substring(0, 10) : '';
      this.editForm.products = JSON.parse(JSON.stringify(this.order.products));
      this.editForm.discount = 0;
    },
    saveEdit() {
      this.editForm.put(`/orders/${this.order.id}`, {
        preserveScroll: true,
        onSuccess: () => {
          this.isEditing = false;
        }
      });
    },
    back() {
      window.history.back()
    },
    orderFinish() {
      this.$inertia.get('/order/'+this.order.id+'/finish')
    },
    cancelOrder() {
      if(this.order.pays.length > 0) {
        return alert('No se puede anular una orden con pagos, primero anule los pagos')
      }
      if (confirm('¿Estás seguro que quieres anular esta orden?')) {
        window.location.href = `/orders/${this.order.id}/cancel`
      }
    },
    addDispatch() {
      this.products.post('/orders/dispatch')
    },
    getStatusText(state) {
      const statusMap = {
        'cancel': 'ANULADA',
        'request': 'PENDIENTE POR PAGO',
        'finish': 'CUOTA PAGADA',
        'payRevition': 'PAGO EN REVISION',
        'pay': 'PAGADA',
        'delivery': 'EN ESPERA DE DESPACHO'
      }
      return statusMap[state] || state
    },
    getStatusClass(state) {
      const classMap = {
        'cancel': 'bg-red-100 text-red-800',
        'request': 'bg-yellow-100 text-yellow-800',
        'finish': 'bg-green-100 text-green-800',
        'payRevition': 'bg-blue-100 text-blue-800',
        'pay': 'bg-green-100 text-green-800',
        'delivery': 'bg-purple-100 text-purple-800'
      }
      return classMap[state] || 'bg-gray-100 text-gray-800'
    },
    shareWhatsApp() {
      const baseUrl = this.$page.props.appUrl.replace(/\/$/, '')
      const orderType = this.order.order_state === 'finish' ? 'recibo' : 'aviso de cobro'
      const message = `Hola vecino, puede visualizar el detalle del ${orderType} presionando aquí: ${baseUrl}/orders/${this.order.id}/report-storer-external`;
      const whatsappUrl = `https://wa.me/?text=${encodeURIComponent(message)}`;
      window.open(whatsappUrl, '_blank');
    },
    shareEmail() {
      const baseUrl = this.$page.props.appUrl.replace(/\/$/, '')
      const isFinish = this.order.order_state === 'finish'
      const orderTypeTitle = isFinish ? 'Recibo' : 'Aviso de cobro'
      const orderTypeLower = isFinish ? 'recibo' : 'aviso de cobro'
      const companyName = this.$page.props.auth?.user?.account?.reasonName || this.$page.props.auth?.user?.account?.name || ''
      const subject = companyName ? `${orderTypeTitle} - ${companyName}` : orderTypeTitle
      const body = `Hola vecino, puede visualizar el detalle del ${orderTypeLower} presionando aquí: ${baseUrl}/orders/${this.order.id}/report-storer-external`;
      const mailtoUrl = `mailto:${this.order.client.email}?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
      window.location.href = mailtoUrl;
    },
  },
}
</script>
